import React, { useState, useEffect } from 'react';
import { Pool, Miner } from '../types';
import { apiService, formatters } from '../services/api';

const MinersPage: React.FC = () => {
  const [pools, setPools] = useState<Pool[]>([]);
  const [miners, setMiners] = useState<Miner[]>([]);
  const [selectedPool, setSelectedPool] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPools();
  }, []);

  useEffect(() => {
    if (selectedPool) {
      loadMiners();
    }
  }, [selectedPool]);

  const loadPools = async () => {
    try {
      const poolData = await apiService.getPools();
      setPools(poolData);
      if (poolData.length > 0) {
        setSelectedPool(poolData[0].id);
      }
    } catch (error) {
      console.error('Error loading pools:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadMiners = async () => {
    try {
      if (!selectedPool) return;
      const minerData = await apiService.getPoolMiners(selectedPool);
      setMiners(minerData);
    } catch (error) {
      console.error('Error loading miners:', error);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
        <p>Loading miners...</p>
      </div>
    );
  }

  return (
    <div className="miners-page">
      <h2>Top Miners</h2>
      <div className="miners-controls">
        <select 
          value={selectedPool} 
          onChange={(e) => setSelectedPool(e.target.value)}
          className="form-select"
        >
          <option value="">Select Pool</option>
          {pools.map(pool => (
            <option key={pool.id} value={pool.id}>
              {pool.coin} ({pool.algorithm})
            </option>
          ))}
        </select>
      </div>
      
      <div className="miners-table-container">
        <table className="miners-table">
          <thead>
            <tr>
              <th>Address</th>
              <th>Hashrate</th>
              <th>Balance</th>
              <th>Last Activity</th>
            </tr>
          </thead>
          <tbody>
            {miners.map((miner, index) => (
              <tr key={`${miner.address}-${index}`}>
                <td>{miner.address.slice(0, 12)}...{miner.address.slice(-8)}</td>
                <td>{formatters.hashrate(miner.hashrate)}</td>
                <td>{formatters.balance(miner.balance)}</td>
                <td>{formatters.timeAgo(miner.lastActivity)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MinersPage;